import React from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";

import Ring from "../../../../Assets/images/flawless-img/shop-by-category/rings.png";
import WeddingRings from "../../../../Assets/images/flawless-img/shop-by-category/wedding-ring.png";
import Bracelets from "../../../../Assets/images/flawless-img/shop-by-category/bracelates.png";
import Pendants from "../../../../Assets/images/flawless-img/shop-by-category/pendants.png";
import { Je_welryspelling } from "../../../../Helpers/request";
import Slider from "react-slick";

const ExploreCollection = () => {
  var settingsCetagory = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const categoryData =[
    {
      id:1,
      title:"Engagement Rings",
      image:Ring,
      link:"/ringsettings"
    },
    {
      id:2,
      title:"Wedding Rings",
      image:WeddingRings,
      link:"/jewelry/wedding-rings"
    },
    {
      id:3,
      title:"Bracelets",
      image:Bracelets,
      link:"/jewelry/bracelets"
    },
    {
      id:4,
      title:"Pendants",
      image:Pendants,
      link:"/jewelry/pendants"
    },

  ]
  return (
    <section className="explore-collection section-space">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Shop by category</h2>
          {/* <p>Explore  {Je_welryspelling}  Collections by Style and Make a Statement.</p> */}
        </Heading>

        <Row>

         
          <Slider {...settingsCetagory} className="w-100 f_category_slider">

  
        {categoryData.map((val)=>(
          <div>
   <div className="f_cat_slider_outer">
   <div className="item text-center">
     <Link to={val.link} className="img-box">
       <Image src={val.image} alt={val.title} className="w-100"/>
     </Link>
     <Link to={val.link}>{val.title}</Link>
   </div>
</div>
          </div>

        ))} 
          </Slider>
        </Row>
      </Container>
    </section>
  );
};

export default ExploreCollection;
